import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as _ from 'underscore';

import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

@Component({
	selector: 'app-daypart-chart',
	styleUrls: ['./daypart-chart.component.css'],
	templateUrl: './daypart-chart.component.html'
})
export class DaypartChartComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() colors: string;
	@Input() groupby: string;
	@Input() colorsconfig: any;
	@Input() downloadconfig: any;
	@Input() legend: any;
	@Input() piechartconfiguration: any;
	@Input() dateformat: any;
	@Input() secondarykey: any;
	@Input() daypartmetric: any;
	@Input() sectionclass: any;
	@Input() downloadcsvcolumns: any;

	public showLoad = true;
	public selectedPie = null;
	public daypartChartObjArray: any[] = [];
	public colorPalette: ColorPalette;
	public selectedFieldName = '';
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns: any;
	public daypartLabel: string;
	public hasData = true;
	public reloadSubscription;
	public widgetDataSubscription;
	public startDate;
	public endDate;
	public chartConfigObj;
	public isVerticalScrollable = false;
	public rowHeight = 50;
	public isR9: boolean;
	public displayOrder = {
		Afternoon: 101,
		Day: 2,
		'Early Fringe': 3,
		Evening: 102,
		'Late Fringe': 7,
		Morning: 1,
		Night: 103,
		Overnight: 8,
		Prime: 6,
		'Prime Access': 4,
		'Prime+': 5,
		Unknown: 100
	};
	public columns: any;
	public cssClasses: any = {
		pagerLeftArrow: 'datatable-icon-left',
		pagerNext: 'datatable-icon-skip',
		pagerPrevious: 'datatable-icon-prev',
		pagerRightArrow: 'datatable-icon-right',
		sortAscending: 'datatable-icon-down',
		sortDescending: 'datatable-icon-up'
	};
	public timezone: string = '';
	public downloadIcon: any = false;
	protected processCustomServiceRequest = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		if (this.isR9) {
			this.displayOrder.Night = 102;
			this.displayOrder.Evening = 103;
		}
		this.chartConfigObj = JSON.parse(decodeURI(this.piechartconfiguration));
		this.legend = JSON.parse(decodeURI(this.legend));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
	}

	ngAfterViewInit(): void {
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.startDate =
			this.dateformat !== 'null'
				? moment(this.analyticsDataModel.startDate).format(this.dateformat)
				: moment(this.analyticsDataModel.startDate).format('MMM D, YYYY');
		this.endDate =
			this.dateformat !== 'null'
				? moment(this.analyticsDataModel.endDate).format(this.dateformat)
				: moment(this.analyticsDataModel.endDate).format('MMM D, YYYY');
		//process using secondary key if key is not present
		if (this.secondarykey !== 'undefined') {
			this.widgetDataSubscription = this.analyticsService.processCustomServiceRequest(this.secondarykey);
		} else {
			this.widgetDataSubscription = this.processCustomServiceRequest
				? this.analyticsService.processCustomServiceRequest(this.key)
				: this.analyticsService.processWidgetRequest(this.key);
		}

		this.widgetDataSubscription = this.widgetDataSubscription.subscribe((response: any) => {
			this.showLoad = false;
			this.timezone = response && response.timezone ? `(${response.timezone})` : '';
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		this.daypartChartObjArray = this.buildDayPartChartCollatorByFields(responseData);

		if (this.chartConfigObj.series && this.chartConfigObj.series.length > 0) {
			//find the configuration for color
			this.daypartChartObjArray[0].chartObj.map((data: any) => {
				let seriesConfig: any = _.where(this.chartConfigObj.series, { seriesName: data.name });
				if (seriesConfig.length > 0) {
					data.color = this.colorUtilityService.getRGBByColorType(
						this.colorPalette,
						seriesConfig[0].colorConfig.color,
						seriesConfig[0].colorConfig.opacity
					);
					data.index = seriesConfig[0].index;
				}
				if (!data.color) {
					data.color = '#EFEFEF';
				}
			});
			//sort by index
			this.daypartChartObjArray[0].chartObj = _.sortBy(this.daypartChartObjArray[0].chartObj, 'index');
		} else {
			this.daypartChartObjArray[0].chartObj.map((data, index) => {
				if (data.dayparttime) {
					data.color = data.name.toLowerCase().includes('unknown') ? '#EFEFEF' : this.getColorFromColorConfig(index, 1);
				}
			});
		}
	}

	buildDayPartChartCollatorByFields(daypartResponseData: any): any[] {
		const fieldChartArray: any[] = [];
		const chartObjArray: any[] = [];
		const daypartData: any = {};
		this.daypartLabel =
			this.daypartmetric != 'undefined' && this.daypartmetric != 'null' ? this.daypartmetric : 'Aired Spots';
		for (const data of daypartResponseData) {
			if (data) {
				const chartObj: any = {};
				chartObj.name = data.daypart === 'ROS' ? 'Run of Service' : data.daypart;
				chartObj.dayparttime = data.daypart_time ? data.daypart_time : data.friendly_name;
				chartObj.market = data.market;
				chartObj.y =
					this.daypartmetric != 'undefined' && this.daypartmetric != 'null'
						? Number(data[this.daypartmetric])
						: Number(data.airedSpots);
				chartObj.displayOrder = this.displayOrder[data.daypart] ? this.displayOrder[data.daypart] : 9;
				chartObj.isHighlighted = false;
				chartObjArray.push(chartObj);
			}
		}
		daypartData.chartObj = _.sortBy(chartObjArray, 'displayOrder');
		fieldChartArray.push(daypartData);
		setTimeout(() => {
			jQuery('.ngx-datatable .datatable-body .datatable-scroll').css({ width: '100%' });
		}, 0);
		return fieldChartArray;
	}

	downloadCSV($event: any): void {
		$event.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	hightLightLabels(index: any): void {
		this.daypartChartObjArray[0].chartObj.forEach((element) => {
			element.isHighlighted = false;
		});
		if (this.daypartChartObjArray[0] && this.daypartChartObjArray[0].chartObj[index]) {
			this.daypartChartObjArray[0].chartObj[index].isHighlighted = true;
		}
	}
	getTitle(name: any, time: any): string {
		const str = `${name} ${time}`;
		return str.replace(/<br\s*\/?>/gm, '\n');
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];

		const fillOpacity = colorConfig ? colorConfig.opacity : opacity;
		let rgb = '';
		if (colorConfig && colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else if (colorConfig && colorConfig.color) {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		} else if (index % 2 === 0) {
			const colorObj = this.colorsconfig[index % this.colorsconfig.length];
			const hexCode = !colorObj.isHex
				? this.colorUtilityService.getHEXByColorType(this.colorPalette, colorObj.color, colorObj.opacity)
				: colorObj.color;
			rgb = this.colorUtilityService.getBrightColor(hexCode, index, colorObj.opacity);
		} else if (index % 2 === 1) {
			const colorObj = this.colorsconfig[index % this.colorsconfig.length];
			const hexCode = !colorObj.isHex
				? this.colorUtilityService.getHEXByColorType(this.colorPalette, colorObj.color, colorObj.opacity)
				: colorObj.color;
			rgb = this.colorUtilityService.getDarkColor(hexCode, index, colorObj.opacity);
		}
		return rgb;
	}
}
